import { Clear, PermIdentityOutlined } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { BorrowerInformationForm } from '../fixFlip/borrowerInformationForm';
import { OneToolCard } from '../fixFlip/oneToolCard';
import { FORM_MAX_WIDTH, LoanSubType } from '../../utils/constants';
import { useQuoteTypeStore } from '../../hooks/useQuoteTypeStore';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Button, ButtonProps, IconButton } from '@roc/ui';

export const BorrowerFormCard = observer(({ borrowerFormStore }) => {
  const { quoteTypeStore } = useQuoteTypeStore();
  const { borrowersStore } = quoteTypeStore;
  const showRemoveButton = borrowersStore.borrowerFormStores.length > 1;
  return (
    <OneToolCard
      maxWidth={FORM_MAX_WIDTH}
      icon={PermIdentityOutlined}
      title="Add Borrower"
      actions={
        <>
          {showRemoveButton && (
            <IconButton
              testId="remove-borrower"
              aria-label="Remove borrower"
              onClick={() =>
                borrowersStore.removeBorrower(borrowerFormStore.key)
              }
            >
              <Clear />
            </IconButton>
          )}
        </>
      }
    >
      <BorrowerInformationForm
        store={borrowerFormStore}
        showActions={false}
        displayPGField
        onDeleteClick={() => null}
        showTitle={false}
      />
    </OneToolCard>
  );
});

const blueTheme = createTheme({
  palette: {
    primary: {
      main: 'rgba(229, 246, 253, 1)',
      contrastText: 'rgba(28, 63, 120, 1)',
    },
  },
});

export const CustomButton = (props: ButtonProps) => {
  return (
    <MuiThemeProvider theme={blueTheme}>
      <Button {...props} color="primary" variant="contained" />
    </MuiThemeProvider>
  );
};
